<template>
  <v-container
    fluid
    :class="BeyondSelected ? 'loggingpage' : ''"
    style="min-height: 100dvh; border-radius: 0; overflow: auto"
  >
    <v-row
      align="center"
      class="fill-height"
      :class="{
        'justify-center': !BeyondSelected,
        'justify-left': BeyondSelected,
      }"
    >
      <v-col
        :cols="12"
        :sm="8"
        :md="6"
        :lg="5"
        :class="BeyondSelected ? 'beyond-margin' : ''"
      >
        <v-card
          rounded="0"
          :class="BeyondSelected ? 'transparent' : 'cardspace'"
        >
          <v-toolbar
            flat
            dense
            color="#005F95"
            class="d-flex justify-center align-center"
          >
            <div>
              <!-- Small to Large Screens -->
              <h3
                class="Login-Toolbar text-center"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '18px',
                  padding: isSmall ? '50px' : '50px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h3>
            </div>
          </v-toolbar>

          <v-container
            fluid
            style="border: 1px solid #ccc; border-radius: 0; padding: 16px"
          >
            <v-container fluid style="border-radius: 0; padding: 16px">
              <v-row>
                <v-col cols="12">
                  <h1 class="Login-Tittle" style="text-align: center">
                    USER LOGIN DETAILS:
                  </h1>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12" sm="">
                  <v-text-field
                    v-model="txtEmailaddress"
                    label="Email"
                    @keyup="uppercase"
                    required
                    clearable
                    placeholder=""
                    maxlength="50"
                    variant="underlined"
                    density="comfortable"
                    prepend-inner-icon="mdi-email"
                    counter
                    type="email"
                    color="#005F95"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row justify="center" align="center">
                <v-col cols="12" sm="">
                  <v-text-field
                    v-model="txtCellphone"
                    label="Cell Number"
                    required
                    clearable
                    placeholder=""
                    counter
                    variant="underlined"
                    density="comfortable"
                    prepend-inner-icon="mdi-phone"
                    maxlength="10"
                    type=""
                    color="#005F95"
                    style="text-align: center"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="12" class="text-center">
                  <v-btn
                    style="border-radius: 0; width: 300px; height: 30px"
                    @click="loginDetails($event)"
                    color="#005F95"
                    class="white--text"
                    :loading="isLoading"
                  >
                    <span v-if="!isLoading">CONTINUE</span>
                  </v-btn>
                </v-col>
                <div>
                  <p
                    v-if="respMessageNF === 'NOT FOUND'"
                    id="message"
                    class="text-center"
                    style="font-size: 14px"
                  >
                    {{ message }}
                  </p>
                </div>

                <div>
                  <p
                    v-if="respMessageF === 'NEWOTPSENT'"
                    id="message"
                    class="text-center"
                    style="font-size: 14px"
                  >
                    {{ message }}
                  </p>
                </div>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
/* eslint-disable */
import { useDisplay } from "vuetify/lib/framework.mjs";
import { ref, onBeforeMount, computed, onMounted, nextTick } from "vue";
import { useRouter } from "vue-router";
import axios from "axios"; // Import axios if not globally available
const refNumber = sessionStorage.getItem("refNumber");
const IDType = sessionStorage.getItem("IDType");
const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const product = ref("");
const router = useRouter();
const prodtype = ref(sessionStorage.getItem("prodtype"));

const BeyondSelected = ref(false);
const txtCellphone = ref("");
const txtEmailaddress = ref("");
const loginOptions = ref("SMS");
const message = ref("");
const respMessageNF = ref(""); // NOT FOUNT
const respMessageF = ref(""); // FOUND
const isLoading = ref(false);

onBeforeMount(() => {
  // Get product type from session storage
  prodtype.value = sessionStorage.getItem("prodtype");

  const productMap = {
    platinum: "CREDIT CARD",
    shariah: "SHARI'AH CARD",
    beyond: "BEYOND CARD",
  };
  product.value = productMap[prodtype.value] || "CREDIT CARD";
  BeyondSelected.value = prodtype.value === "beyond";

  //   if (refNumber) {
  //     // GetUserForReferenceNumber();
  //   } else {
  //     router.push("/");
  //   }
});

//Adjust the login card based on the product type.
const colClass = computed(() =>
  BeyondSelected.value
    ? "xs12 sm6 offset-sm4 lg4 offset-lg2"
    : "xs12 sm6 offset-sm4 lg4 offset-lg4"
);

// Methods / Functions
const uppercase = () => {
  txtEmailaddress.value = txtEmailaddress.value.toUpperCase();
};

const loginDetails = async (event) => {
  event.preventDefault();
  isLoading.value = true;

  if (!loginOptions.value && !txtCellphone.value && !txtEmailaddress.value) {
    console.log("Missing input fields");
    isLoading.value = false;

    return;
  }

  try {
    const response = await axios.post("/auth/login", {
      _COMM_TYPE: loginOptions.value,
      _EMAIL: txtEmailaddress.value,
      _TELEPHONE: txtCellphone.value,
    });

    const authToken =
      response.headers["authorization"] || response.headers["Authorization"];
    if (authToken) {
      sessionStorage.setItem("authToken", authToken); // Store the token in local storage
    }
    // console.log(sessionStorage.getItem("authToken"))

    if (response.data.data === "NEWOTPSENT") {
      isLoading.value = false;
      
      sessionStorage.setItem("userid", response.data._USERID);
      sessionStorage.setItem("refNumber", response.data._REFNUMBER);
      sessionStorage.setItem("maskedCell", response.data._MASKEDCELL);
      sessionStorage.setItem("comtype", response.data._COMM_TYPEOUT);
      sessionStorage.setItem("otpCheck", response.data.data);
      //alert(response.data.OTP)
      router.push("/UserOTP");
    } else if (response.data.data === "NOT FOUND") {
      isLoading.value = false;
      respMessageNF.value = response.data.data;
      message.value =
        "Incorrect Email Address or Contact Number. Please try again";
      router.push("/UserLogin"); // Change to: router.push("/UserLogin")
    } else {
      isLoading.value = false;
      respMessageF.value = response.data.data;
      message.value =
        "There is an issue with retrieving your login details. Please try again later.";
      router.push("/UserLogin");
    }
  } catch (error) {
    console.error(error);
    isLoading.value = false;
    router.push("/TechnicalError");
  }
};
</script>

<style scoped>
#border {
  border-top: 3px solid #000;
}

@font-face {
  font-family: "GathamLight";
  src: url("@/assets/fonts/Gotham-Light.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Light.otf") format("opentype");
  font-display: swap;
}
p {
  text-align: left;
  font-family: "GathamLight";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

.Login-Tittle {
  font-family: "GathamLight";
  font-size: 20px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #041e42;
}

h1 {
  color: #041e42;
}

@font-face {
  font-family: "GathamBookLimit";
  src: url("@/assets/fonts/Gotham-Book.woff2") format("woff2"),
    url("@/assets/fonts/Gotham-Book.otf") format("opentype");
  font-display: swap;
}

.Login-Toolbar {
  font-family: "GathamBookLimit";
  /* font-size: 10px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
  /* padding: 30px; */
}
#warning {
  color: #9f6000;
}

#message {
  color: #d8000c;
}
.loggingpage {
  background: url("../assets/images/BeyondBI.jpeg") no-repeat center center;
  background-size: cover;


}
/* .transparent {
  background-color: transparent;
} */
.cardspace {
  margin-top: 40px;
}

@media (min-width: 1280px) {
  .beyond-margin {
    margin-left: 50px; 
    padding-top: 40px;
  }
}
</style>
